const HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT = 15000;

export { HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT };
